export enum ProjectDeleteError400Type {
  HAS_USERS_VERIFIERS = 'has users verifiers',
  HAS_ASSETS = 'has assets',
  HAS_GATEWAYS = 'has gateways',
  HAS_CAMERAS = 'has cameras',
  HAS_INTERCOMS = 'has intercoms',
  HAS_COMMON_AREAS = 'has common areas',
}
